import "@/user/common";
import "@/shared/calendar";
import "@/user/page/fair/reserve_modal";
import "@/user/page/fair/search_modal";

// 同日開催のフェアをもっと見る
const moreBtn = document.getElementsByClassName("js-more_btn");
Array.from(moreBtn).forEach((btn) => {
  btn.addEventListener("click", (e) => {
    const parent = e.currentTarget.parentNode;
    const label = parent.querySelector(".js-more_label");
    const closeLabel = parent.querySelector(".js-more_close");

    if (label.style.display === "none") {
      label.style.display = "block";
      closeLabel.style.display = "none";
      parent.classList.remove("is-open");
    } else {
      closeLabel.style.display = "block";
      label.style.display = "none";
      parent.classList.add("is-open");
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  // 絞り込み機能のときは検索ボックスからスタート
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("fair-search")) {
    const element = document.querySelector(".js-fair-result-conditions");

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
});

// カルーセルを閉じた時、一番最初のカセットに戻る
const closeBtn = document.getElementsByClassName("js-more_close");
Array.from(closeBtn).forEach((btn) => {
  btn.addEventListener("click", (e) => {
    const parent = e.currentTarget.closest(".js-fair-result"); // ここで適切な親要素を見つける
    if (parent) {
      parent.scrollIntoView({
        behavior: "smooth",
      });
    }
  });
});

// ソート条件変更
const sortSelect = document.getElementById("js-sort_select");
if (sortSelect) {
  const currentUrl = new URL(window.location.href);
  // クエリなしのURL
  const url = currentUrl.origin + currentUrl.pathname;
  const query = currentUrl.searchParams;

  // 選択された条件でリダイレクト
  sortSelect.addEventListener("change", (e) => {
    query.delete("group_by");
    if (e.currentTarget.value === "fair") {
      // プルダウンの値がフェアの場合はgroup_by指定をqueryに追加
      query.append("group_by", "id");
    }

    // 絞り込みのクエリパラメータを削除
    query.delete("fair-search");
    // ページ開始番号を初期化
    query.delete("page");

    const queryString =
      query.toString().length > 0 ? `?${query.toString()}` : "";

    // ソートを切り替え+fair-search&pageを初期化してリダイレクト
    window.location.href = `${url}${queryString}`;
  });
}
